module.exports = __webpack_public_path__ + "static/media/gdg.6364dbb3.png";